import { render, staticRenderFns } from "./addapp.vue?vue&type=template&id=322d870e&scoped=true"
import script from "./addapp.vue?vue&type=script&lang=js"
export * from "./addapp.vue?vue&type=script&lang=js"
import style0 from "./addapp.vue?vue&type=style&index=0&id=322d870e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d870e",
  null
  
)

export default component.exports